(function () {
  'use strict';

  var COLLECTION_URL = '/collections/insektenschutz-nach-mass';
  var ELIGIBLE_PRODUCT_IDS = [6965867249869, 9447985021193, 9451489952009, 9451471601929];
  var EASIFY_MIN_WIDTH_MM = 1100;
  var EASIFY_GATED_OPTION_TERMS = ['pollenschutz', 'barrierefrei'];

  function createTimeBadge() {
    var badge = document.createElement('div');
    badge.className = 'advisory-form__time-badge';
    badge.setAttribute('role', 'note');
    badge.innerHTML =
      '<span class="advisory-form__time-badge-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" focusable="false"><path d="M9 2h6v2H9V2Zm2 11.6V7h2v5.6l3.4 2-1 1.7L11 13.6ZM12 22a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" fill="currentColor"/></svg>' +
      '</span>' +
      '<span>Fenster ausmessen in nur <strong>3 Minuten</strong></span>';
    return badge;
  }

  function ensureTimeBadge(form) {
    if (form.querySelector('.advisory-form__time-badge')) return;

    var intro = form.querySelector('.advisory-form__intro');
    var badge = createTimeBadge();

    if (intro) {
      intro.insertAdjacentElement('afterend', badge);
    } else {
      form.insertBefore(badge, form.firstChild);
    }
  }

  function enhanceSlimLinks(form) {
    form.querySelectorAll('a.advisory-form__inline-link[href*="slim-fliegengitter-zum-schieben"]').forEach(function (link) {
      if (link.dataset.nsSlimButton === 'true') return;

      link.dataset.nsSlimButton = 'true';
      link.className = 'button button--solid button--regular advisory-form__result-btn advisory-form__slim-button';
      link.innerHTML = '<span class="button__text">Zum extra dünnen SLIM-Fliegengitter</span>';
    });
  }

  function createSupportNote() {
    var note = document.createElement('p');
    note.className = 'advisory-form__support-note';
    note.innerHTML = 'Unsicher beim Ausmessen? <a href="/pages/contact">Support fragen</a> – Foto vom Fenster reicht.';
    return note;
  }

  function ensureSupportNote(form) {
    if (!form.classList.contains('advisory-form-one-step') && !form.querySelector('.advisory-form__config-scroll')) return;
    if (form.querySelector('.advisory-form__support-note')) return;

    var target = form.querySelector('.advisory-form__image-wrapper') || form.querySelector('.advisory-form__step-image');
    if (!target) return;

    target.insertAdjacentElement('afterend', createSupportNote());
  }

  function findConfiguratorBlocks(form) {
    var blocks = [];
    var node = form.nextElementSibling;
    var foundTitle = false;
    var foundActions = false;

    while (node && (!foundTitle || !foundActions)) {
      if (!foundTitle && node.classList && node.classList.contains('product-title-subtitle')) {
        blocks.push(node);
        foundTitle = true;
      } else if (!foundActions && node.classList && node.classList.contains('product-actions')) {
        blocks.push(node);
        foundActions = true;
      }
      node = node.nextElementSibling;
    }

    return blocks;
  }

  function getLockedPlaceholder(form) {
    var placeholder = form.nextElementSibling;
    return placeholder && placeholder.classList.contains('advisory-form__locked-config') ? placeholder : null;
  }

  function ensureLockedPlaceholder(form) {
    var placeholder = getLockedPlaceholder(form);
    if (placeholder) return placeholder;

    placeholder = document.createElement('div');
    placeholder.className = 'advisory-form__locked-config';
    placeholder.innerHTML =
      '<button type="button" class="button button--regular advisory-form__locked-button" disabled aria-disabled="true">' +
        '<span class="button__text">Schließe zuerst Schritt 1 ab</span>' +
      '</button>';
    form.insertAdjacentElement('afterend', placeholder);
    return placeholder;
  }

  function setConfiguratorState(form, complete) {
    var placeholder = getLockedPlaceholder(form);

    form.classList.toggle('advisory-form--complete', complete);

    if (complete) {
      if (placeholder) placeholder.remove();
    } else {
      ensureLockedPlaceholder(form).hidden = false;
    }

    findConfiguratorBlocks(form).forEach(function (block) {
      block.classList.toggle('ns-advisory-configurator-locked', !complete);
      if (complete) {
        block.removeAttribute('aria-hidden');
        block.removeAttribute('inert');
      } else {
        block.setAttribute('aria-hidden', 'true');
        block.setAttribute('inert', '');
      }
    });
  }

  function initAdvisoryForm(form) {
    if (form.dataset.nsEnhanced === 'true') return;
    form.dataset.nsEnhanced = 'true';

    ensureTimeBadge(form);

    if (form.classList.contains('advisory-form-one-step')) {
      form.classList.add('advisory-form--complete');
      enhanceSlimLinks(form);
      ensureSupportNote(form);
      return;
    }

    function sync() {
      enhanceSlimLinks(form);
      ensureSupportNote(form);
      var complete = !!form.querySelector('.advisory-form__config-scroll');
      setConfiguratorState(form, complete);
    }

    sync();
    new MutationObserver(sync).observe(form, { childList: true, subtree: true });
  }

  function initAdvisoryForms() {
    document.querySelectorAll('.advisory-form').forEach(initAdvisoryForm);
  }

  function getDiscountState(count) {
    if (count >= 5) {
      return { percent: 100, message: '10 % Rabatt gesichert.', discount: 10 };
    }
    if (count === 4) {
      return { percent: 80, message: '7 % erreicht – noch 1 Fliegengitter bis 10 % Rabatt.', discount: 7 };
    }
    if (count === 3) {
      return { percent: 60, message: '7 % erreicht – noch 2 Fliegengitter bis 10 % Rabatt.', discount: 7 };
    }
    if (count === 2) {
      return { percent: 40, message: '5 % erreicht – noch 1 Fliegengitter bis 7 % Rabatt.', discount: 5 };
    }
    if (count === 1) {
      return { percent: 20, message: 'Noch 1 Fliegengitter bis 5 % Rabatt.', discount: 0 };
    }
    return { percent: 0, message: 'Lege 2 Fliegengitter in den Warenkorb und sichere dir 5 % Rabatt.', discount: 0 };
  }

  function countEligibleItems(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return ELIGIBLE_PRODUCT_IDS.indexOf(Number(item.product_id)) !== -1 ? total + Number(item.quantity || 0) : total;
    }, 0);
  }

  function getDiscountApplications(cart) {
    var applications = [];

    function add(application) {
      if (!application) return;
      var key = [
        application.type || '',
        application.title || '',
        application.value_type || '',
        application.value || ''
      ].join('|');

      if (!applications.some(function (entry) { return entry.key === key; })) {
        applications.push({ key: key, application: application });
      }
    }

    (cart.cart_level_discount_applications || []).forEach(add);

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        add(allocation.discount_application);
      });
    });

    return applications.map(function (entry) { return entry.application; });
  }

  function getAppliedDiscountPercent(cart) {
    var applications = getDiscountApplications(cart);
    var percentage = applications.reduce(function (maximum, application) {
      if (application.value_type !== 'percentage') return maximum;
      var value = Number(String(application.value || '').replace(',', '.'));
      return Number.isFinite(value) ? Math.max(maximum, value) : maximum;
    }, 0);

    if (percentage > 0) return percentage;

    if (
      applications.length > 0 &&
      Number(cart.total_discount) > 0 &&
      Number(cart.original_total_price) > 0
    ) {
      return Number(cart.total_discount) / Number(cart.original_total_price) * 100;
    }

    return 0;
  }

  function updateProgress(root, cart) {
    if (!root) return;

    var count = countEligibleItems(cart);
    var state = getDiscountState(count);
    var appliedDiscount = getAppliedDiscountPercent(cart);
    var hasBetterDiscount = appliedDiscount > state.discount + 0.05;
    var fill = root.querySelector('[data-ns-discount-fill]');
    var title = root.querySelector('[data-ns-discount-title]');
    var message = root.querySelector('[data-ns-discount-message]');
    var status = root.querySelector('[data-ns-discount-status]');
    var track = root.querySelector('.ns-cart-discount__track');
    var continueLink = root.querySelector('[data-ns-continue-shopping]');

    root.dataset.eligibleCount = String(count);
    root.classList.toggle('ns-cart-upsell--better-discount', hasBetterDiscount);

    if (hasBetterDiscount) {
      if (title) title.textContent = 'Besserer Rabatt aktiv';
      if (message) {
        message.textContent = 'Du hast bereits einen besseren Rabatt angewendet. Der Staffelrabatt kann deshalb nicht zusätzlich genutzt werden.';
      }
      if (status) status.textContent = 'Rabattcode aktiv';
      if (track) track.hidden = true;
      if (continueLink) continueLink.hidden = true;
      return;
    }

    if (title) title.textContent = 'Staffelrabatt';
    if (message) message.textContent = state.message;
    if (status) status.textContent = 'Momentan: ' + state.discount + ' % Rabatt';
    if (track) {
      track.hidden = false;
      track.setAttribute('aria-valuenow', String(state.percent));
    }
    if (fill) fill.style.width = state.percent + '%';
    if (continueLink) continueLink.hidden = false;

    root.querySelectorAll('[data-ns-milestone]').forEach(function (milestone) {
      milestone.classList.toggle('is-achieved', count >= Number(milestone.dataset.nsMilestone));
    });
  }

  function createCartUpsell() {
    var section = document.createElement('section');
    section.className = 'ns-cart-upsell';
    section.setAttribute('data-ns-cart-upsell', '');
    section.innerHTML =
      '<div class="ns-cart-discount">' +
        '<div class="ns-cart-discount__topline">' +
          '<div><strong data-ns-discount-title>Staffelrabatt</strong><p data-ns-discount-message></p></div>' +
          '<span class="ns-cart-discount__status" data-ns-discount-status>Momentan: 0 % Rabatt</span>' +
        '</div>' +
        '<div class="ns-cart-discount__track" role="progressbar" aria-label="Fortschritt zum Staffelrabatt" aria-valuemin="0" aria-valuemax="100">' +
          '<span class="ns-cart-discount__fill" data-ns-discount-fill></span>' +
          '<span class="ns-cart-discount__milestone ns-cart-discount__milestone--two" data-ns-milestone="2"><i></i><small>2 Stk. · 5 %</small></span>' +
          '<span class="ns-cart-discount__milestone ns-cart-discount__milestone--three" data-ns-milestone="3"><i></i><small>3 Stk. · 7 %</small></span>' +
          '<span class="ns-cart-discount__milestone ns-cart-discount__milestone--five" data-ns-milestone="5"><i></i><small>5 Stk. · 10 %</small></span>' +
        '</div>' +
        '<a href="' + COLLECTION_URL + '" class="button button--regular button--outline button--move ns-cart-continue" data-ns-continue-shopping>' +
          '<span class="button__text">Weiter einkaufen</span>' +
        '</a>' +
      '</div>';
    return section;
  }

  function updateEmptyCartLinks() {
    document.querySelectorAll('#AjaxCartForm .gutter-top--regular a.button').forEach(function (link) {
      if (/weiter|brows/i.test(link.textContent || '') || /collections\/all/.test(link.getAttribute('href') || '')) {
        link.href = COLLECTION_URL;
      }
    });
  }

  function initCartEnhancements() {
    if (!document.body.classList.contains('template-cart')) return;

    var subtotal = document.getElementById('AjaxCartSubtotal');
    if (!subtotal) return;

    updateEmptyCartLinks();

    var oldContinueLink = subtotal.querySelector('[data-ns-continue-shopping]');
    if (oldContinueLink) oldContinueLink.remove();

    var root = document.querySelector('[data-ns-cart-upsell]');
    if (!root) {
      root = createCartUpsell();
      var cartSection = subtotal.closest('.cart-section');
      if (cartSection) {
        cartSection.insertAdjacentElement('afterend', root);
      } else {
        subtotal.insertAdjacentElement('afterend', root);
      }
    }

    function refreshCart() {
      updateEmptyCartLinks();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { updateProgress(root, cart); })
        .catch(function () {});
    }

    refreshCart();

    var cartForm = document.getElementById('AjaxCartForm');
    if (cartForm) cartForm.addEventListener('cart-updated', refreshCart);
    document.addEventListener('krown:cart:update', refreshCart);
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function parseDimensionValue(value) {
    var match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  }

  function getLabelForInput(input) {
    if (input.id) {
      var escapedId = window.CSS && CSS.escape ? CSS.escape(input.id) : input.id.replace(/"/g, '\\"');
      var explicitLabel = document.querySelector('label[for="' + escapedId + '"]');
      if (explicitLabel) return explicitLabel;
    }
    return input.closest('label');
  }

  function getInputDescriptor(input) {
    var label = getLabelForInput(input);
    return normalizeText([
      input.name,
      input.id,
      input.getAttribute('aria-label'),
      input.getAttribute('placeholder'),
      input.dataset && Object.keys(input.dataset).map(function (key) { return input.dataset[key]; }).join(' '),
      label && label.textContent,
      input.closest('[class*="easify"], [class*="option"], .product-form__input, .form-field, .field') &&
        input.closest('[class*="easify"], [class*="option"], .product-form__input, .form-field, .field').textContent
    ].filter(Boolean).join(' '));
  }

  function isMeasureInput(input) {
    if (!input || !input.matches || !input.matches('input, select, textarea')) return false;
    var type = normalizeText(input.type);
    if (/checkbox|radio|button|submit|hidden|file/.test(type)) return false;
    return /breite|width/.test(getInputDescriptor(input));
  }

  function getConfiguredWidth() {
    var candidates = Array.prototype.slice.call(document.querySelectorAll('input, select, textarea'))
      .filter(isMeasureInput)
      .map(function (input) {
        return {
          input: input,
          value: parseDimensionValue(input.value),
          score: /breite/.test(getInputDescriptor(input)) ? 2 : 1
        };
      })
      .filter(function (candidate) { return candidate.value !== null; })
      .sort(function (a, b) { return b.score - a.score; });

    return candidates.length ? candidates[0].value : null;
  }

  function elementLooksVisible(element) {
    if (!element || !element.isConnected) return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    var current = element;
    while (current && current !== document.documentElement) {
      var style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      current = current.parentElement;
    }

    return true;
  }

  function textMatchesGatedOption(text) {
    var normalized = normalizeText(text);
    return EASIFY_GATED_OPTION_TERMS.some(function (term) {
      return normalized.indexOf(term) !== -1;
    });
  }

  function getOptionContainer(input) {
    return getLabelForInput(input) ||
      input.closest('[class*="easify"], [class*="option"], .product-form__input, .form-field, .field, li, div') ||
      input.parentElement;
  }

  function findGatedOptionControls() {
    var controls = [];
    var seen = [];

    function add(input) {
      if (!input || !input.matches || !input.matches('input[type="checkbox"], input[type="radio"]')) return;
      if (seen.indexOf(input) !== -1) return;
      seen.push(input);
      controls.push(input);
    }

    document.querySelectorAll('label').forEach(function (label) {
      if (!textMatchesGatedOption(label.textContent)) return;
      if (label.htmlFor) add(document.getElementById(label.htmlFor));
      label.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(add);
    });

    document.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
      var container = getOptionContainer(input);
      if (container && textMatchesGatedOption(container.textContent)) add(input);
    });

    return controls;
  }

  function dispatchEasifyEvent(target, type) {
    var event;
    if (/mouse|click|pointer/.test(type)) {
      event = new MouseEvent(type, { bubbles: true, cancelable: true, view: window });
    } else {
      event = new Event(type, { bubbles: true, cancelable: true });
    }
    target.dispatchEvent(event);
  }

  function notifyEasifyOptionChanged(input) {
    ['input', 'change'].forEach(function (type) {
      dispatchEasifyEvent(input, type);
    });

    var form = input.closest('form');
    if (form) dispatchEasifyEvent(form, 'change');
  }

  function clickEasifyControlOff(input) {
    if (!input.checked) return false;

    if (input.disabled) input.disabled = false;

    var clickable = getLabelForInput(input) || input;
    ['pointerdown', 'mousedown', 'mouseup'].forEach(function (type) {
      dispatchEasifyEvent(clickable, type);
    });

    clickable.click();

    if (input.checked) {
      input.click();
    }

    if (input.checked) {
      input.checked = false;
      input.removeAttribute('checked');
    }

    input.defaultChecked = false;
    notifyEasifyOptionChanged(input);
    window.setTimeout(function () { notifyEasifyOptionChanged(input); }, 50);
    window.setTimeout(function () { notifyEasifyOptionChanged(input); }, 200);

    return !input.checked;
  }

  function unsetEasifyControl(input) {
    if (input.dataset.nsEasifyLocking === 'true') return;

    input.dataset.nsEasifyLocking = 'true';

    if (input.checked) {
      clickEasifyControlOff(input);
    } else {
      input.removeAttribute('checked');
      input.defaultChecked = false;
      notifyEasifyOptionChanged(input);
    }

    window.setTimeout(function () {
      if (!input.checked) {
        input.dataset.nsEasifyDisabled = 'true';
        input.disabled = true;
        notifyEasifyOptionChanged(input);
      }
      delete input.dataset.nsEasifyLocking;
    }, 80);
  }

  function restoreEasifyControl(input) {
    if (input.dataset.nsEasifyDisabled === 'true') {
      input.disabled = false;
      delete input.dataset.nsEasifyDisabled;
      notifyEasifyOptionChanged(input);
    }
  }

  function syncEasifyGatedOptions() {
    if (window.location.pathname.indexOf('fliegengitter-zum-schieben') === -1) return;

    var width = getConfiguredWidth();
    var belowThreshold = width !== null && width < EASIFY_MIN_WIDTH_MM;

    findGatedOptionControls().forEach(function (input) {
      var container = getOptionContainer(input);
      var hiddenByUi = width === null && container && !elementLooksVisible(container);

      if (belowThreshold || hiddenByUi) {
        unsetEasifyControl(input);
      } else {
        restoreEasifyControl(input);
      }
    });
  }

  function initEasifyOptionGuard() {
    if (window.location.pathname.indexOf('fliegengitter-zum-schieben') === -1) return;

    var timer = null;
    function schedule() {
      window.clearTimeout(timer);
      timer = window.setTimeout(syncEasifyGatedOptions, 80);
    }

    document.addEventListener('input', function (event) {
      if (event.target && event.target.matches && event.target.matches('input, select, textarea')) schedule();
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('input, select, textarea')) schedule();
    }, true);

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'checked', 'disabled', 'value']
    });

    schedule();
    window.setTimeout(schedule, 500);
    window.setTimeout(schedule, 1500);
  }

  function init() {
    initAdvisoryForms();
    initCartEnhancements();
    initEasifyOptionGuard();

    new MutationObserver(function (mutations) {
      var needsAdvisoryScan = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (node.matches('.advisory-form') || node.querySelector('.advisory-form'));
        });
      });
      if (needsAdvisoryScan) initAdvisoryForms();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();